"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TertiaryButton = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var base_1 = require("./base");
exports.TertiaryButton = styled_components_1.default(base_1.BaseButton).attrs(function (_a) {
    var isDisabled = _a.isDisabled, theme = _a.theme;
    return ({
        style: isDisabled === true ? {
            backgroundColor: theme.colors.gray.s200,
            border: "1px solid " + theme.colors.gray.s200,
            color: theme.colors.gray.s500,
            cursor: 'auto'
        } : undefined
    });
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  color: ", ";\n\n  &:hover {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n  \n  &:active {\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n  color: ", ";\n\n  &:hover {\n    border: 1px solid ", ";\n    color: ", ";\n  }\n  \n  &:active {\n    background-color: ", ";\n    border: 1px solid ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s300;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.gray.s700;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.base;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.tap;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.main.tap;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white.s100;
});
exports.TertiaryButton.displayName = 'TertiaryButton';
var templateObject_1;
